module.exports = __webpack_public_path__ + "img/img_supplier_hxf@2x.cdfac1a5.png";